export default __webpack_public_path__ + "static/media/bg-countdown.9e5480f3.png";